import { areCloseScalar } from "./vectorUtils";

export const roundIfSmall = (num: number, prec: number = 0.001): number => {
  const roundedVal = areCloseScalar(num, Math.round(num), prec)
    ? Math.round(num)
    : Math.round(1000 * num) / 1000;
  return roundedVal;
};
